export default __webpack_public_path__ + "static/media/action-card-liquidity-mining-generic.0dcb8667.svg";